module.exports = "data:image/gif;base64,R0lGODlhEAAQAKUxAAAAADVJYzZKZC9iyDFlzTly4j5240B240Z75Ep940D/QE6B5FaG5ViH5WKO5myU526X52WV82qZ9Xab6Hqf6XGd9X+h6Xei9n2n+ICAgJOit5alupqpvp6uw4Sl6Yam6ouq6oSr+Yuw+pC1+5a5/Jq9/aOyyKe2zJ/A/qLC/9Dg8ODg8ODo8PDw8PDw//D4///4/////////////////////////////////////////////////////////////yH5BAEKAD8ALAAAAAAQABAAAAZiwJ9wSCwaj8hkEcT8WCYPR2NhKBBBKRRpJAphLpUIgXiKmc/ml0tANMUAcED6xQoQO+i5q07kmDOAgRkrdkMbeWdqhUIab3FzfEONeS9qkYxoMGotLCqLPxoBoqOkn0qnSUEAOw=="


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/leaf.gif
 ** module id = 284
 ** module chunks = 0 1
 **/